import React from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Assets from 'app/configs/assetConfigs'
import { isNil } from 'ramda'

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.6rem',
  },
  placeName: {
    color: theme.palette.notificationPreview.brownGrey,
  },
  directionRtl: {
    direction: 'rtl',
  },
}))

const PreviewEventPlace = ({ title = null, placeName }) => {
  const classes = useStyles()
  return (
    <div className="flex flex-col mt-8 mx-16" dir="auto">
      {!isNil(title) && (
        <span className={clsx(classes.title, 'font-bold')}>{title}</span>
      )}
      <div className="flex mt-6">
        <span className={clsx(classes.placeName, 'font-base')}>
          {placeName}
        </span>
      </div>
    </div>
  )
}

export default PreviewEventPlace
